import { fetchAuth } from "../../../shared/api/ApiService"
import { IAssignShiftRequest, IGetShiftCalendarRequest, IGetShiftCalendarResponse, IGetShiftRequest,
    IGetShiftResponse, IGetStaffShiftCalendarRequest, IGetStaffShiftCalendarResponse, IReplaceShiftCoordinatorRequest,
    IReplaceShiftCuratorRequest, IShiftResponse, IUpdateStaffShiftPatternRequest, IUpdateStaffShiftPatternResponse } from "../model/types"

class ShiftService {
    
    async getShiftCalendar(data: IGetShiftCalendarRequest): Promise<IGetShiftCalendarResponse> {
        const res = await fetchAuth(`${process.env.REACT_APP_SERVER_URL_ADMIN}/api/v1/shifts/calendar`, {
            method: 'POST',
            body: JSON.stringify(data),
        })

        return await res.json() as IGetShiftCalendarResponse
    }

    async getShift(data: IGetShiftRequest): Promise<IGetShiftResponse> {
        const res = await fetchAuth(`${process.env.REACT_APP_SERVER_URL_ADMIN}/api/v1/shifts/day`, {
            method: 'POST',
            body: JSON.stringify(data),
        })

        return await res.json() as IGetShiftResponse
    }

    async getStaffShiftCalendar(data: IGetStaffShiftCalendarRequest): Promise<IGetStaffShiftCalendarResponse> {
        const res = await fetchAuth(`${process.env.REACT_APP_SERVER_URL_ADMIN}/api/v1/shifts/staff/${data.userId}/calendar`, {
            method: 'POST',
            body: JSON.stringify(data),
        })

        return await res.json() as IGetStaffShiftCalendarResponse
    }

    async updateStaffShiftPattern(data: IUpdateStaffShiftPatternRequest): Promise<IUpdateStaffShiftPatternResponse> {
        const res = await fetchAuth(`${process.env.REACT_APP_SERVER_URL_ADMIN}/api/v1/shifts/staff/${data.userId}/pattern`, {
            method: 'POST',
            body: JSON.stringify(data),
        })

        return await res.json() as IUpdateStaffShiftPatternResponse
    }

    async assignShift(data: IAssignShiftRequest): Promise<IShiftResponse> {
        const res = await fetchAuth(`${process.env.REACT_APP_SERVER_URL_ADMIN}/api/v1/shifts/assign`, {
            method: 'POST',
            body: JSON.stringify(data),
        })

        return await res.json() as IShiftResponse
    }

    async replaceShiftCoordinator(data: IReplaceShiftCoordinatorRequest): Promise<IShiftResponse> {
        const res = await fetchAuth(`${process.env.REACT_APP_SERVER_URL_ADMIN}/api/v1/shifts/${data.shiftId}/coordinator/replace`, {
            method: 'POST',
            body: JSON.stringify(data),
        })

        return await res.json() as IShiftResponse
    }

    async replaceShiftCurator(data: IReplaceShiftCuratorRequest): Promise<IShiftResponse> {
        const res = await fetchAuth(`${process.env.REACT_APP_SERVER_URL_ADMIN}/api/v1/shifts/${data.shiftId}/curator/replace`, {
            method: 'POST',
            body: JSON.stringify(data),
        })

        return await res.json() as IShiftResponse
    }
}

export const shiftService = new ShiftService()
